import apiClient from "../apiClient";

const resource = "notifications";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    approval: id => apiClient.put(`${resource}/${id}/approval`),
    cancel: id => apiClient.put(`${resource}/${id}/cancel`),
    extension: id => apiClient.put(`${resource}/${id}/extension`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),

};
